import { render, staticRenderFns } from "./ModalAddHospitalRegraGarantiaMinima.vue?vue&type=template&id=babb501e&scoped=true"
import script from "./ModalAddHospitalRegraGarantiaMinima.vue?vue&type=script&lang=ts"
export * from "./ModalAddHospitalRegraGarantiaMinima.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babb501e",
  null
  
)

export default component.exports